import "@shoelace-style/shoelace/dist/components/icon/icon.js";
import "@shoelace-style/shoelace/dist/components/button/button.js";
import "@shoelace-style/shoelace/dist/components/button-group/button-group.js";
import "@shoelace-style/shoelace/dist/components/tooltip/tooltip.js";

import { css, html } from "lit";
import { customElement } from "lit/decorators.js";
import { BaseElement } from "./BaseElement";
import { Style } from "./Styles";
import { ThemeDark } from "./ThemeDark";

@customElement("ds-place-toolbar")
export class PlaceToolbar extends BaseElement {
    static override styles = [Style, ThemeDark, css``];

    override render() {
        return html`
            <sl-button-group
                @sl-hide=${(e: Event) => e.stopPropagation()}
                @sl-after-hide=${(e: Event) => e.stopPropagation()}
            >
                <sl-tooltip content="View on map">
                    <sl-button @click=${() => this._raiseEvent("ds-view-on-map")}
                        ><sl-icon name="pin-map-fill" label="View on map"></sl-icon
                    ></sl-button>
                </sl-tooltip>
                <sl-tooltip content="Navigate here">
                    <sl-button @click=${() => this._raiseEvent("ds-navigate")}
                        ><sl-icon name="send-fill" label="Navigate here"></sl-icon
                    ></sl-button>
                </sl-tooltip>
                <sl-tooltip content="Open in maps">
                    <sl-button @click=${() => this._raiseEvent("ds-open-in-map-app")}
                        ><sl-icon name="car-front-fill" label="Open in maps"></sl-icon
                    ></sl-button>
                </sl-tooltip>
                <sl-tooltip content="Open gallery">
                    <sl-button @click=${() => this._raiseEvent("ds-open-gallery")}
                        ><sl-icon name="images" label="Open gallery"></sl-icon
                    ></sl-button>
                </sl-tooltip>
            </sl-button-group>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-place-toolbar": PlaceToolbar;
    }
}
